import React from "react";
import useHideShowDropDown from "../../helpers/hideshowdropdown";

const BoardModal = (props) => {
  useHideShowDropDown(props.refs, () => {
    props.hideBoardModal();
  });
  return (
    <>
      {props.show && (
        <div class="adding-content rename-modal" ref={props.refs}>
          {props.children}
        </div>
      )}
    </>
  );
};

export default BoardModal;
